export const HEADERS = [
	'No.',
	'Full name',
	'Email',
	'Phone',
	'Status',
	'Actions',
];
